import {Box, HStack, useTheme} from '@chakra-ui/react';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {updateUser} from '../../../endpoints/api';
import useAuth from '../../../hooks/useAuth';
import * as pushService from '../../../pushService';
import {isIphone, deviceDetected} from '../../../utils/deviceCheck';
import {useUpdateNotificationPreference} from '../../../hooks/useEvent';
import {EventNotificationsModalActions} from '../../../state/EventNotificationsModal/EventNotificationsModalSlice';
import {LabelledCheckboxGrey} from '../../checkbox';
import {TextG10} from '../../typography';

const ChatNotificationsNudge = ({articleId}: {articleId: number}) => {
  const theme = useTheme();
  const [notificationsChecked, setNotificationsChecked] = useState(true);
  const {reFetchUserData} = useAuth();
  const dispatch = useDispatch();
  const {mutateAsync} = useUpdateNotificationPreference();

  const confirmClicked = async () => {
    if (notificationsChecked) {
      // Enable email and SMS notifications immediately
      const updateData: any = {email_enabled: true, sms_enabled: true};
      
      // Handle push notifications - need to get device token first
      if (window['ReactNativeWebView']) {
        // React Native app - request permission (token will be handled by event listener)
        pushService.pushPermissionRequest();
        updateData.push_enabled = true;
      } else if (!isIphone) {
        // Non-iOS web - can get token directly
        try {
          const token = await pushService.askNotificationPermission();
          if (token) {
            updateData.device_token = token;
            updateData.device_platform = deviceDetected();
            updateData.push_enabled = true;
          }
        } catch (error) {
          console.error('Failed to get push notification token:', error);
          // Don't set push_enabled without a token
        }
      } else {
        // iOS web - request permission (token will be handled by event listener)
        pushService.pushPermissionRequest();
        // Don't set push_enabled here - the event listener will handle it when token is received
      }
      
      await updateUser(updateData);
      reFetchUserData();
    } else {
      mutateAsync({
        eventId: articleId,
        receiveNotifications: false,
      });
    }
  };

  return (
    <HStack
      mx="-5%"
      background={theme.colors.lightGrey}
      py={4}
      px={6}
      justifyContent="space-between">
      <Box
        onClick={() => {
          //setNotificationsChecked((prev) => !prev);
          dispatch(EventNotificationsModalActions.pushEventNotifications({eventId: articleId}));
        }}>
        <LabelledCheckboxGrey
          styled={true}
          isCircle={false}
          label="We’ll notify you about event updates and chat."
          checked={notificationsChecked}
          onChange={(e) => e}
          disabled={false}
        />
      </Box>
      <TextG10 onClick={confirmClicked} fontWeight="500" color={theme.colors.blue}>
        Confirm
      </TextG10>
    </HStack>
  );
};

export default ChatNotificationsNudge;
